module.exports = __webpack_public_path__ + "img/failure.6cb46745.svg";